let content_blocks = require('../contents');
let background_colors = [];


export function init(){

    background_colors = window.background_colors;

    $('#edit_divider').find('.btn.btn-danger.delete_media').each(function(){
        $(this).on('click', function() {
            let modal = $(this).closest('.modal');
            let block_id = modal.find('[name="block_id"]').val();
            let block = $('#'+ block_id);
            let background = JSON.parse(block.attr('data-background'));
            let media_id = background.media_id;
            content_blocks.delete_media(media_id);
            background['media_id'] = '';
            background['url'] = '';
            background['img_name'] = '';
            block.attr('data-background', JSON.stringify(background));
            block.find('.card-body:first').css('background-image', 'url()');
        })
    });

    $('#edit_divider_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_divider').find('.visibility-devices span').each(function(){
        $(this).on('click', function(){
            let hidden = $(this).attr('data-hidden') == true || $(this).attr('data-hidden') == 'true' ? true : false;
            change_device_visible($(this), !hidden);
            $(this).attr('data-hidden', !hidden);
        });
    });

    function change_device_visible(button, hidden){
        if (hidden == true || hidden == 'true') {
            button.css({"background-color": "#f8f9fa"});
        } else {
            button.css({"background-color": "#d3d6d9"});
        }
    }

    $('#edit_divider_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        modal.find('[name="classes"]').val(block.attr('data-class'));

        let background = JSON.parse(block.attr('data-background'));
        let color = background['color'];
        let img_name = background['img_name'];
        let url = background['url'];
        let media_id = background['media_id'];

        let translations = [];

        try {

            translations = JSON.parse(block.attr('data-translations'));
            if(typeof translations[window._content_selected_language] != 'undefined'){
                
                if(typeof translations[window._content_selected_language]['background']['color'] != 'undefined'){
                    color = translations[window._content_selected_language]['background']['color'];
                }

                if(typeof translations[window._content_selected_language]['background']['img_name'] != 'undefined'){
                    img_name = translations[window._content_selected_language]['background']['img_name'];
                }

                if(typeof translations[window._content_selected_language]['background']['url'] != 'undefined'){
                    url = translations[window._content_selected_language]['background']['url'];
                }
                
                if(typeof translations[window._content_selected_language]['background']['media_id'] != 'undefined'){
                    media_id = translations[window._content_selected_language]['background']['media_id'];
                }

            }

        } catch(err){}

        let device_mobile = modal.find('.visibility-devices [data-device="mobile"]');
        device_mobile.attr('data-hidden', block.attr('data-mobile-hidden'));
        change_device_visible(device_mobile, block.attr('data-mobile-hidden'));
        
        let device_tablet = modal.find('.visibility-devices  [data-device="tablet"]');
        device_tablet.attr('data-hidden', block.attr('data-tablet-hidden'));
        change_device_visible(device_tablet, block.attr('data-tablet-hidden'));
        
        let device_desktop = modal.find('.visibility-devices [data-device="desktop"]');
        device_desktop.attr('data-hidden', block.attr('data-desktop-hidden'));
        change_device_visible(device_desktop, block.attr('data-desktop-hidden'));

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="xs_height"]').val(block.attr('data-xs-height'));
        modal.find('[name="md_height"]').val(block.attr('data-md-height'));
        modal.find('[name="xl_height"]').val(block.attr('data-xl-height'));
        modal.find('[name="ignore_ratio"]').prop('checked', block.attr('data-ignore-ratio') == 'true' ? true : false);
        let color_select = modal.find('select[name="bg-color"]');
        let position_select = modal.find('select[name="bg-position"]');
        
        if (color != null) {
            color_select.find('option[value="'+ color +'"]').prop('selected', true);
        } else {
            color_select.find('option:nth-child(1)').prop('selected', true);
        }
        color_select.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let image = modal.find('input[name="divider_img"]');
        let label = image.next('label');
        label.text(img_name);
    });

    $('#edit_divider').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());
        
        let background = JSON.parse(block.attr('data-background'));
        background['color'] = $(this).find('[name="bg-color"]').val();

        let translations = [];
        if(window._content_languages.length > 1){

            try {
                translations = JSON.parse(block.attr('data-translations'));
                if (translations.length == 0) {
                    translations = {}
                }
            } catch(err){
                translations = [];
            }

            // preparo traducciones que no existan

            for(let _language of window._content_languages){
                if(typeof translations[_language] == 'undefined'){
                    translations[_language] = {'background' : { 'color': background['color'], 'img_name': background['img_name'] , 'url': background['url'], 'media_id': background['media_id'] }}
                }
            }

            // guardo tranduccion actual 
            translations[window._content_selected_language]['background']['color'] = background['color'];
            translations[window._content_selected_language]['background']['img_name'] = background['img_name'];
            translations[window._content_selected_language]['background']['url'] = background['url'];
            translations[window._content_selected_language]['background']['media_id'] = background['media_id'];

            // si es idioma base

            if(window._content_selected_language == window._locale){

                block.attr('data-background', JSON.stringify(background));

                // actualizamos traducciones vacias

                for(let _language of window._content_languages){
                    if(_language != window._locale){
                        if(translations[_language]['background']['color'] == ''){
                            translations[_language]['background']['color'] = background['color'];
                        }
                        if(translations[_language]['background']['url'] == ''){
                            translations[_language]['background']['url'] = background['url'];
                        }
                        if(translations[_language]['background']['img_name'] == ''){
                            translations[_language]['background']['img_name'] = background['img_name'];
                        }
                        if(translations[_language]['background']['media_id'] == ''){
                            translations[_language]['background']['media_id'] = background['media_id'];
                        }
                    }
                }

            }

        } else {
            block.attr('data-background', JSON.stringify(background));
        }

        let device_mobile = $(this).find('.visibility-devices [data-device="mobile"]');
        block.attr('data-mobile-hidden', device_mobile.attr('data-hidden'));
        
        let device_tablet = $(this).find('.visibility-devices  [data-device="tablet"]');
        block.attr('data-tablet-hidden', device_tablet.attr('data-hidden'));
        
        let device_desktop = $(this).find('.visibility-devices [data-device="desktop"]');
        block.attr('data-desktop-hidden', device_desktop.attr('data-hidden'));

        
        block.attr('data-ignore-ratio', $(this).find('[name="ignore_ratio"]').prop('checked'));
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        block.attr('data-xs-height', $(this).find('[name="xs_height"]').val());
        block.attr('data-md-height', $(this).find('[name="md_height"]').val());
        block.attr('data-xl-height', $(this).find('[name="xl_height"]').val());
        block.attr('data-translations', JSON.stringify(translations));
        
        let form_data = new FormData($(this)[0]);

        if (form_data.get('divider_img').name != '') {
            update_background_image(form_data, block);
        }
        
        content_blocks.change_visible_button_blocks(block);
        if (background['color'] != '') {
            change_background_view(block);
        }

        let modal = $(this).closest('.modal');
        modal.modal('hide');

        $(this)[0].reset();
    });


    $('.block[data-type="divider"]').each(function() {
        content_blocks.create_visible_button_blocks($(this));
    })
}


function update_background_image(form_data, block) {
    let url = window._routes['microsites.contents.media'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    form_data.append('type', block.attr('data-type'));
    window.forms.post(url, form_data, true, true)
        .then((response) => {

            if (response.data != null) {
                let background = JSON.parse(block.attr('data-background'));
                background['url'] = response.data.src;
                background['img_name'] = response.data.name;
                background['media_id'] = response.data.media_id;
                block.attr('data-background', JSON.stringify(background));

                if(window._content_languages.length > 1){
                    translations = JSON.parse(block.attr('data-translations'));

                    translations[window._content_selected_language]['background']['url'] = response.data.src;
                    translations[window._content_selected_language]['background']['media_id'] = response.data.media_id;
                    translations[window._content_selected_language]['background']['img_name'] = response.data.name;

                    block.attr('data-translations', JSON.stringify(translations));
                }

                block.find('.card-body:first').css('background-image', 'url('+ response.data.src +')');
            }
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
        });
}

function change_background_view(block){
    let background = JSON.parse(block.attr('data-background'));
    let background_color = '';
    let type_color = background.color;
    if (type_color != '') {
        let version_color = background_colors[type_color];
        let color = version_color['color'];
        let opacity = version_color['shade'];
        background_color = background_colors['colors'][color][opacity];
    }

    block.find('.card-body:first').css('background-color', background_color);
}